import(/* webpackMode: "eager" */ "/app/components/LinkComponent.js");
import(/* webpackMode: "eager" */ "/app/components/TestamonialCard.js");
import(/* webpackMode: "eager" */ "/app/components/TestamonialCardSlider.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js")